import React, { useState } from "react";

import { useTranslation } from 'react-i18next';

// nodejs library to set properties for components
import PropTypes from "prop-types";

import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

// @mui/icons-material
import Check from '@mui/icons-material/Check';
import MDTypography from "../components/MDTypography";
import MDBox from "../components/MDBox";



export default function OthelloCheckBox({ ...props }) {

    const { label, labelliteral, disabled, fieldname } = props;

    const [checkedstate, setcheckedstate] = useState(props.checked);
    const [evento, setevento] = useState(false);

    const { t } = useTranslation();


    const handleOnChange = (event) => {

        if (props.readonly != null && props.readonly) {

            setcheckedstate(true)
            setevento(true);
        }
        //Si cambio el estado anterior
        else if (event.target != checkedstate) {
            setcheckedstate(event.target.checked)
            setevento(true);

            if (props.onChange != null)
                props.onChange(event.target.id, event.target.checked);
        }
    }

    let labelfinal = t != null && labelliteral != null ? t(labelliteral) : label;

    //Si el que ha provocado el cambio es el evento entonces el valor del input es el que viene del evento, pero sino, el valor sera el de por defecto    
    let estadofinal = evento ? checkedstate : props.checked;

    //Limpiamos que el cambio ha sido por el evento, por si en otro lugar se ha realizado el deshacer, o al principio, que en esos casos debe tomar el de por defecto
    //evento = false;

    return (
        <div>
            <MDBox sx={{ mx: 0.5 }}>
                <Checkbox
                    id={fieldname}
                    name={fieldname}
                    checked={estadofinal}
                    onChange={(e) => handleOnChange(e)}
                    checkedIcon={<Check />}
                    icon={<Check />}
                    value={estadofinal}
                    disabled={disabled}
                    color={estadofinal ? "secondary" : "default"}
                />
                <MDTypography variant="button" fontWeight="medium" sx={{ lineHeight: 'normal', fontSize: 14 }}>
                    {labelfinal}
                </MDTypography>
            </MDBox>
        </div>
    );
}


OthelloCheckBox.propTypes = {
    classes: PropTypes.object.isRequired,
    fieldname: PropTypes.string,
    labelliteral: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.object,
    checked: PropTypes.bool,
    disabled: PropTypes.bool
};

